import { render, staticRenderFns } from "./KBSelectFlow.vue?vue&type=template&id=58a6b864&scoped=true&"
import script from "./KBSelectFlow.vue?vue&type=script&lang=ts&"
export * from "./KBSelectFlow.vue?vue&type=script&lang=ts&"
import style0 from "./KBSelectFlow.vue?vue&type=style&index=0&id=58a6b864&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6b864",
  null
  
)

export default component.exports